import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(),
    },
    message: {
        display: 'inline-block',
        margin: `${theme.spacing()}px ${theme.spacing(2)}px`,
    },
    success: {
        color: '#76ab53',
    },
    error: {
        color: '#f00',
    },
    button: {
        color: '#fff !important',
        background: '#76ac53',
        padding: '6px 16px',
        '&:hover': {
            opacity: 0.7,
            background: '#76ac53',
        },
        '&[disabled]': {
            opacity: 0.5,
        },
    },
});

const STATUS_INIT = {
    loading: false,
    success: false,
    failed: false,
};

const MESSAGES_INIT = {
    loading: 'Loading...',
    success: 'Authentication successful',
    failed: 'Authentication failed',
};

const StatusActionForm = withStyles(styles)(
    ({ status, messages, disabled, onVerify, classes }) => {
        messages = { ...MESSAGES_INIT, ...messages };
        return (
            <div className={classes.root}>
                <Button
                    color="secondary"
                    onClick={onVerify}
                    className={classes.button}
                    disabled={disabled}
                >
                    Authenticate
                </Button>
                <div className={classes.message}>
                    <Typography>
                        {status.loading && <span>{messages.loading}</span>}
                        {status.success && (
                            <span className={classes.success}>
                                {messages.success}
                            </span>
                        )}
                        {status.failed && (
                            <span className={classes.error}>
                                {messages.failed}
                            </span>
                        )}
                    </Typography>
                </div>
            </div>
        );
    }
);

StatusActionForm.propTypes = {
    status: PropTypes.shape({
        loading: PropTypes.bool,
        success: PropTypes.bool,
        failed: PropTypes.bool,
    }),
    messages: PropTypes.shape({
        loadning: PropTypes.string,
        success: PropTypes.string,
        failed: PropTypes.string,
    }),
    onVerify: PropTypes.func.isRequired,
};

StatusActionForm.defaultProps = {
    status: STATUS_INIT,
    messages: MESSAGES_INIT,
};

export default StatusActionForm;
